import LoadingSpinner from '@components/shared/Loading/Loading'
import QuranReaderContainer from '@components/Reader/QuranReaderContainer'
import useQuranPageData from '@hooks/useQuranPageData'
import { hasNativeQuranBridge } from 'helpers/nativeQuranBridge'
import {
  getQuranPageStaticPaths,
  getQuranPageStaticProps,
  type QuranPageProps,
} from 'helpers/quranPageProps'
import { parseQuranRoutePage, resolveQuranRoutePage } from 'helpers/quranRoutes'
import { DefaultSeo } from 'next-seo'
import { useRouter } from 'next/router'

/** Renders a Quran page with static browser data and native/network fallbacks. */
const KuranPage = ({ page, ayahs, pageData }: QuranPageProps) => {
  const router = useRouter()

  const mobileReader = hasNativeQuranBridge()
  const serverPage = parseQuranRoutePage(page)
  const routePage = resolveQuranRoutePage(router.query.page, page)
  const { page: resolvedPage, status } = useQuranPageData({
    routePage,
    serverPage,
    serverAyahs: ayahs,
    serverPageData: pageData,
  })

  if (status === 'unavailable') {
    return (
      <p className="mx-auto mt-8 max-w-md rounded-xl border border-subtle bg-surface-subtle p-4 text-center text-sm text-muted">
        Bu özelliği kullanmak için Hayırhah uygulamasını güncellemeniz gerekiyor. Lütfen
        uygulama mağazasından en son sürüme güncelleyin.
      </p>
    )
  }

  if (routePage === null) {
    return <LoadingSpinner />
  }

  const routePageLabel = String(routePage)

  return (
    <>
      <DefaultSeo
        title={`${routePageLabel}. Sayfa - Kuran-ı Kerim Kelime Mealli Oku | Hayırhah`}
        description={`${routePageLabel}. Sayfa - Kuran-ı Kerim Kelime Mealli Oku Ve Dinle. İsterseniz Hayrat ve diğer baskıları da seçebilirsiniz. Kaldığınız yeri işaretleyebilirsiniz.`}
      />
      <QuranReaderContainer
        page={routePage}
        ayahs={resolvedPage?.ayahs}
        pageData={resolvedPage?.pageData}
        mobileReader={mobileReader}
        isContentReady={status === 'ready'}
      />
    </>
  )
}

export default KuranPage

export const getStaticProps = getQuranPageStaticProps
export const getStaticPaths = getQuranPageStaticPaths
